// Run this example by adding <%= javascript_pack_tag 'hello_react' %> to the head of your layout file,
// like app/views/layouts/application.html.erb. All it does is render <div>Hello React</div> at the bottom
// of the page.

import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import 'whatwg-fetch'

// const interests = [
//   {id: 4, name: 'Hulp bij vergroten sociale contacten'},
//   {id: 2, name: 'Gezellig/sociaal contact/ondernemen leuke activiteiten'},
//   {id: 1, name: 'Ondersteuning en begeleiding'},
// ]
//
// const age_groups = [
//   {id: 1, name: 'Kinderen'},
//   {id: 2, name: 'Jongeren'},
//   {id: 3, name: 'Volwassenen'},
//   {id: 4, name: 'Ouderen'},
// ]

const ProjectItem = props => (
  <div className="c-project-list-item" key={props.id}>
    <a href={props.url}>
      <div className="e-project-logo-container">
        <img src={props.logo} />
      </div>

      <h4>{props.title}</h4>
      <p>{props.description}</p>
      <div className="e-button-container">
        <button className="e-button-project">Bekijk project</button>
      </div>
    </a>
  </div>
)

class SearchForm extends React.Component {

  render() {
    const interests_checkboxes = this.props.interests.map((interest) =>
      <div key={interest.id}>
        <input type="checkbox"
            value={interest.id}
            name="search[field_of_interests_ids][]"
            id={"search_field_of_interests_ids_" + interest.id}
            onChange={this.props.handleChange} />

        <label htmlFor={"search_field_of_interests_ids_" + interest.id}>{interest.name}</label>
      </div>
    )

    const age_groups_checkboxes = this.props.age_groups.map((age_group) =>
      <div key={age_group.id}>
        <input type="checkbox"
            value={age_group.id}
            name="search[age_group_ids][]"
            id={"search_age_group_ids_" + age_group.id}
            onChange={this.props.handleChange} />

        <label htmlFor={"search_age_group_ids_" + age_group.id}>{age_group.name}</label>
      </div>
    )

    return (
      <section className="c-search-form">
        <h4>Verfijn zoekopdracht</h4>

        { this.props.show_interests_checkboxes && (
          <div>
            <p>Interessegebied</p>
            <ul className="e-checkbox-list">
              <li>
                {interests_checkboxes}
              </li>
            </ul>
          </div> ) }

        <p>Leeftijd</p>
        <ul className="e-checkbox-list">
          <li>
            {age_groups_checkboxes}
          </li>
        </ul>

      </section>
    )
  }
}

// const ProjectList = props => (
class ProjectList extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      projects: [],
      selected_interests: [this.props.field_of_interest_id],
      selected_age_groups: [],
    }

    // console.log(this.props);

    this.handleChange = this.handleChange.bind(this);
    this.toggleSearchForm = this.toggleSearchForm.bind(this);
  }

  toggleSearchForm(event) {
    event.preventDefault();
    // TODO: do this the react way
    // $(".c-search-form").toggle();
  }

  handleChange(event) {
    event.stopPropagation();
    // console.log("clicked");
    // console.log('this is:', this);

    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    // const name = target.name;
    const id = parseInt(target.id[target.id.length-1]) //Alert: only works when ids < 10
    const type = target.name.includes('interest') ? 'interests' : 'age_groups'

    // console.log(target, id, type);
    // console.log(id);

    if (value == true) {
      // console.log('add');
      this.setState((prevState, props) => ({
        [`selected_${type}`]: prevState[`selected_${type}`].push(id) && prevState[`selected_${type}`]
      }),() => {
        // console.log(this.state);
        this.fetchProjects();
      })
    } else {
      // console.log('remove');
      this.setState((prevState, props) => ({
        [`selected_${type}`]: prevState[`selected_${type}`].filter(x => x != id)
      }),() => {
        // console.log(this.state);
        this.fetchProjects();
      })
    }
  }

  componentDidMount() {
    this.fetchProjects();
  }

  fetchProjects() {
    let search_arguments = {
      'search': {
        'age_group_ids': this.state.selected_age_groups,
        'field_of_interest_ids': this.state.selected_interests,
        'type': this.props.type,
      }
    }

    // console.log(JSON.stringify(search_arguments))

    return fetch('/projecten/search.json', {
      method: 'POST',
      headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json',
      },
      body: Object.keys(search_arguments).length ? JSON.stringify(search_arguments) : null,

    }).then(response => {
      return response.json()

    }).then(projects => {
      // console.log(projects);
      this.setState({projects: projects});
    });

  }

  render() {
    // console.debug(this.props);
    const projectItems = this.state.projects.map((project) =>
      <ProjectItem key={project.id}
                    id={project.id}
                    title={project.title}
                    logo={project.logo}
                    description={this.props.type == 'find-buddy' ? project.find_buddy_short_description : project.short_description}
                    url={this.props.type == 'find-buddy' ? project.find_buddy_url : project.url} />
    )

    return (
      <section>

        <h2 className="v-page-title v-projects-list v-logo">
          { this.props.page_title || (type == 'find-buddy' ? 'Vind een maatje' : 'Overzicht maatjesprojecten') }
        </h2>

        { this.props.intro_text && <p className="e-project-intro">{this.props.intro_text}</p> }

        <section className="c-search-count">
          <h4>
            {this.state.projects.length} resultaten gevonden
            <span>
              <a href="#" className="e-toggle-search-form" onClick={this.toggleSearchForm}>
                &raquo; verfijn zoekopdracht
              </a>
            </span>
          </h4>
        </section>

        <SearchForm handleChange={this.handleChange}
                    show_interests_checkboxes={!this.props.field_of_interest_id}
                    interests={this.props.interests}
                    age_groups={this.props.age_groups} />

        <section className="c-projects-list">
          {projectItems}
        </section>

      </section>
    )
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const node = document.getElementById('react-root')
  const data = JSON.parse(node.getAttribute('data'))

  ReactDOM.render(
    <ProjectList interests={data.interests}
                 age_groups={data.age_groups}
                 type={data.type}
                 field_of_interest_id={data.field_of_interest_id}
                 page_title={data.page_title}
                 intro_text={data.intro_text} />,
    node,
  )
})



// WEBPACK FOOTER //
// ./app/javascript/packs/project_list.jsx